import React, { useState } from "react";
import { asset } from "../memberData";

export default function MemberAvatar({ member, decorated = false }) {
  const [failedUrl, setFailedUrl] = useState("");
  const src = member.avatar && member.avatar !== failedUrl ? member.avatar : asset("overview-imgRectangle10.png");
  return <div className={decorated ? "member-avatar-decorated" : "member-avatar"}>
    {decorated && <img className="member-avatar-ring" src={asset("overview-imgEllipse5907.svg")} alt="" />}
    <img className="member-avatar-photo" src={src} alt={`Ảnh đại diện ${member.name}`} onError={() => setFailedUrl(src)} />
    {decorated && member.tier !== "member" && <img className={`member-avatar-crown crown-${member.tier}`} src={asset(`crown-${member.tier}.png`)} alt="" />}
  </div>;
}
